import videojs from "video.js";

let ref = []
let promise;

export default async function video(videoElement, options, callback) {
  ref.push(videoElement)
  if (promise) { return promise }
  promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      const element = ref.pop()
      const isInDOM = document.body.contains(element)
      if (isInDOM) {
        const player = videojs(element, options, () => {
          if (callback) callback(player);
          ref = []
          resolve(player)
        });
      }
    }, 1500)
  })
  return promise
}